import { Exclude, Expose } from 'class-transformer';
import { DrawCabinetFrontElement } from './DrawCabinetFrontElement';
import type { IPushPullActionner } from './IPushPullActionner';

export class DrawFrontDrawer extends DrawCabinetFrontElement implements IPushPullActionner {
    IsPushPull!: boolean;
    IsLargeCapacity!: boolean;
}
